import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { getColor } from 'core/utils/Styles';

import Overlay from 'core/components/Overlay';
import Close from 'core/icons/Close';

import {
	ModalWrapper,
	DismissBtn,
	BodyContent,
} from 'core/styles/modal';

class EmptyModal extends PureComponent {
	render() {
		const { open, onClose, children, noOverflow, maxWidth } = this.props;
		if (!open) return null;

		return (
			<Overlay noCloseBtn dismiss={onClose} noOverflow={noOverflow}>
				<ModalWrapper maxWidth={maxWidth}>
					<DismissBtn onClick={onClose} padding={"30px"}>
						<Close width={16} height={16} fill={getColor('black')} stroke={getColor('white')} />
					</DismissBtn>
					<BodyContent>
						{children}
					</BodyContent>
				</ModalWrapper>
			</Overlay>
		);
	}
}

EmptyModal.propTypes = {
	open: PropTypes.bool,
	onClose: PropTypes.func,
	children: PropTypes.node.isRequired,
	noOverflow: PropTypes.bool,
	maxWidth: PropTypes.string,
};

EmptyModal.defaultProps = {
	onClose: () => null,
	maxWidth: "750px",
};

export default EmptyModal;
